export const production = true;

const BASE_DOMAIN = production
  ? "https://sekho.mobi"
  : "https://sekho.ecnstg.com";

export const Config = {
  /** API origin for all network calls. */
  BASE_URL: "https://sekho.mobi",
    // BASE_URL: BASE_DOMAIN,
  /** Default request timeout (ms). */
  TIMEOUT: 80000,

  GUEST_USERNAME: "hakunaMatata",
  GUEST_PASSWORD: "hakunaMatata",

  /** Google Tag Manager container id. */
  GTM_ID: "GTM-54HRS5R8",

  /** CDN bases for course thumbnails (`*_NEW` is the rewrite target). */
  COURSES_THUMBNAIL: "https://sekho.mobi/edu/",
  COURSES_THUMBNAIL_NEW: "https://sekho.mobi/edu/",
  // COURSES_THUMBNAIL: `${BASE_DOMAIN}/edu/`,
  // COURSES_THUMBNAIL_NEW: `${BASE_DOMAIN}/edu/`,

  /** CDN bases for tips thumbnails (`*_NEW` is the rewrite target). */
  TIPS_THUMBNAIL: "https://sekho.mobi/jparho",
  TIPS_THUMBNAIL_NEW: "https://sekho.mobi/jparho",
  // TIPS_THUMBNAIL: `${BASE_DOMAIN}/jparho`,
  // TIPS_THUMBNAIL_NEW: `${BASE_DOMAIN}/jparho`,

  // JazzcashUrl: `${BASE_DOMAIN}/jcms/link-wallet`,
  JazzcashUrl: "https://sekho.mobi/jcms/link-wallet",
  artworkBaseUrl: "https://landingartwork.trivia.mobi/api/",
  recaptchaSiteKey: "6LcbPUstAAAAAGEvt_ilr5CFnR8fPXlRf9P8sRhJ",
} as const;
